import NBType, { InferType } from '@netbase/nb-type'
import GroupMetric from '../enums/GroupMetric'

const GroupMetricResultSchema = NBType.object().shape('GroupMetricResultSchema', {
  /* @prop */
  type: NBType.enum(GroupMetric),
  /* @prop */
  value: NBType.number()
  /* END */
})
export default GroupMetricResultSchema
export type GroupMetricResult = InferType<typeof GroupMetricResultSchema>
// RESERVE BELOW
